export default __webpack_public_path__ + "assets/monitor.bc2ac33f.svg";